import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=25e098d3&"
import script from "./DialogComponent.vue?vue&type=script&lang=js&"
export * from "./DialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e098d3')) {
      api.createRecord('25e098d3', component.options)
    } else {
      api.reload('25e098d3', component.options)
    }
    module.hot.accept("./DialogComponent.vue?vue&type=template&id=25e098d3&", function () {
      api.rerender('25e098d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/DialogComponent.vue"
export default component.exports